/* eslint-disable import/prefer-default-export */
import { formValueSelector } from 'redux-form';
import getTravelerFormSectionName from './travelerFormName';
import { FREQUENT_FLYER_CARD_TYPE } from './constants';
export const getSelected = form => (state, id) => formValueSelector(form)(state, getTravelerFormSectionName(id, FREQUENT_FLYER_CARD_TYPE)) || null;
//# sourceMappingURL=frequentFlyerCardType.js.map